import { render, staticRenderFns } from "./settingPinCode.vue?vue&type=template&id=b3027210&"
import script from "./settingPinCode.vue?vue&type=script&lang=js&"
export * from "./settingPinCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports